import React from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';

interface LocationState {
  documentType: string;
  recipientEmail: string;
}

export default function DocumentCompletePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState | null;

  if (!state?.documentType) {
    return <Navigate to="/document" replace />;
  }

  const isWithholding = state.documentType === '원천징수영수증';

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-xl font-bold text-slate-800">GRK Career Management</h1>
          <p className="text-sm text-slate-500 mt-1">증명서 발급 포털</p>
        </div>

        <div className="bg-white rounded-xl shadow border border-slate-200 p-8 text-center">
          {/* 아이콘 */}
          <div className={`w-14 h-14 ${isWithholding ? 'bg-amber-100' : 'bg-green-100'} rounded-full flex items-center justify-center mx-auto mb-4`}>
            {isWithholding ? (
              <svg className="w-7 h-7 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            ) : (
              <svg className="w-7 h-7 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>

          <h2 className="text-base font-semibold text-slate-800 mb-2">
            {isWithholding ? '발급 요청 접수' : '발송 완료'}
          </h2>
          <p className="text-sm text-slate-600 mb-1">
            <span className="font-medium text-indigo-600">{state.documentType}</span>
            {isWithholding ? ' 발급 요청이' : '가'}
          </p>
          <p className="text-sm text-slate-600 mb-5">
            <span className="font-medium">{state.recipientEmail}</span>
            {isWithholding ? (
              <>
                <br />으로 발송될 예정입니다.
              </>
            ) : (
              <>
                으로<br />발송되었습니다.
              </>
            )}
          </p>

          {isWithholding ? (
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-6">
              <p className="text-xs text-amber-800 leading-relaxed">
                원천징수영수증은 외부 시스템에서 발급되어<br />
                <span className="font-semibold">처리에 수 분~수십 분</span>이 소요될 수 있습니다.<br />
                완료되는 대로 이메일로 발송되오니<br />
                잠시만 기다려주세요.
              </p>
            </div>
          ) : (
            <p className="text-xs text-slate-400 mb-6">
              수신까지 1~2분 소요될 수 있습니다.<br />
              스팸 메일함도 확인해주세요.
            </p>
          )}

          <button
            onClick={() => navigate('/document')}
            className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg transition-colors"
          >
            다른 문서 발급하기
          </button>
        </div>
      </div>
    </div>
  );
}
